import React, { Component } from 'react';
import WmDropdown from '../../Layout/WmDropdown';
export default class BaseList extends Component {
  constructor() {
    super(...arguments);
    this.getOptions = () => [];
    this.getDropdownLabelText = () => '';
    this.getDropdownFieldName = () => '';
    this.getDropdownOnly = () => false;
    this.getPlaceholder = () => 'Select...';
    this.getStyles = () => {};
    this.isSearchable = () => true;
    this.maxMenuHeight = () => 300;
    this.getValue = () => {
      let details = '';
      this.getOptions().forEach(item => {
        if (this.props.multi) {
          details = this.props.currentValue;
        } else if (item.value === this.props.currentValue) {
          details = item;
        }
      });
      return details;
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(WmDropdown, {
      text: this.getDropdownLabelText(),
      name: this.getDropdownFieldName(),
      htmlFor: this.getDropdownFieldName(),
      labelColumns: this.props.labelColumns,
      fieldColumns: this.props.fieldColumns,
      disabled: this.props.disabled,
      dropdownOnly: this.getDropdownOnly(),
      values: this.getValue(),
      options: this.getOptions(),
      onChange: this.props.onChange,
      placeholder: this.getPlaceholder(),
      multi: this.props.multi,
      maxMenuHeight: this.maxMenuHeight(),
      isRequired: this.props.isRequired || false,
      isSearchable: this.isSearchable(),
      styles: this.getStyles()
    });
  }
}